module.exports = __webpack_public_path__ + "assets/3f7e1ebf9cf54ce61946013d45f75b76.mp3";